<template>
  <div class="layout-config">
    <div class="layout-config-body">
      <!-- 左侧：预览（与 galaxy 一致） -->
      <div class="layout-left" :style="leftPaneStyle">
        <div class="pane-inner">
          <div class="pane-header">
            <div class="pane-header-left">
              <p class="pane-title">布局预览</p>
              <div class="pane-sub">
                <p class="pane-sub-line">
                  状态：{{ publishStatusMap[modulesStatus] || "未知" }}
                </p>
                <p class="pane-sub-line">
                  发布时间：{{ latestPublishedAt ? formatDate(latestPublishedAt) : "-" }}
                </p>
              </div>
            </div>
            <el-button type="primary" size="small" @click="openTest(null, 'layout')">
              测试
            </el-button>
          </div>

          <div class="pane-content">
            <layout-config-preview :data="previewData" :loading="previewLoading" />
          </div>
        </div>
      </div>

      <!-- 中间：可拖拽分隔条（与 galaxy 一致） -->
      <div class="layout-splitter" @mousedown="startResize"></div>

      <!-- 右侧：模块列表 -->
      <div class="layout-right">
        <div class="pane-inner">
          <div class="pane-header">
            <p class="pane-title">模块库</p>
            <div class="pane-actions">
              <el-button type="primary" size="small" @click="openLayoutConfig">添加</el-button>
              <el-button type="primary" size="small" @click="saveLayoutConfig">保存</el-button>
              <el-button type="primary" size="small" @click="handlePublish">发布</el-button>
            </div>
          </div>

          <div class="pane-content">
            <div class="table-wrapper">
              <el-table ref="tableRef" :data="dataList" border size="small" :height="tableHeight" v-loading="loading"
                row-key="shipId" @row-click="handleRowClick" style="width: 100%"
                :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
                <el-table-column type="index" label="序号" width="60">
                  <template slot-scope="scope">
                    {{ (params.page - 1) * params.pageSize + scope.$index + 1 }}
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="id" label="模块id" width="100"></el-table-column> -->
                <el-table-column label="缩略图" prop="thumbnail" min-width="110">
                  <template slot-scope="scope">
                    <div v-if="scope.row.resources && scope.row.resources.length" class="thumbnail-cell">
                      <el-image :src="getThumbnail(scope.row.resources[0])" style="height: 40px;" fit="contain"
                        :preview-src-list="getPreviewSrcList(scope.row.resources)" :hide-on-click-modal="true"
                        :lazy="true" />
                    </div>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="类型" prop="type">
                  <template slot-scope="scope">
                    {{ scope.row.type === "1" ? "Banner" : "卡片" }}
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="resourceCount" label="数量"></el-table-column>
                <el-table-column prop="createdAt" label="添加时间">
                  <template slot-scope="scope">
                    {{ formatDate(scope.row.createdAt) }}
                  </template>
                </el-table-column>
                <el-table-column prop="statusText" label="状态"></el-table-column>
                <!-- fixed="right" -->
                <el-table-column label="操作" width="240">
                  <template slot-scope="scope">
                    <div class="op-row">
                      <div class="op-drag">
                        <svg class="drag-btn" width="20" height="20" viewBox="0 0 48 48" fill="none"
                          xmlns="http://www.w3.org/2000/svg" @mouseenter="initSortable">
                          <path d="M8 18H40" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M8 30H40" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M8 6H40" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M8 42H40" stroke="currentColor" stroke-width="4" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <el-button type="danger" size="small" @click.stop="removeLayoutModuleAction([scope.row.id])">
                        移出
                      </el-button>
                      <el-button type="primary" size="small" @click.stop="openTest(scope.row, 'module')">
                        测试
                      </el-button>
                      <el-button type="primary" size="small" @click.stop="openOptRecord(scope.row)">
                        操作详情
                      </el-button>
                      <!-- <div class="op-drag">
                        <i class="el-icon-rank drag-btn" @mouseenter="initSortable"></i>
                      </div> -->
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页器 -->
              <div class="pager">
                <el-pagination background layout="total, prev, pager, next, jumper" :current-page="params.page"
                  :page-size="params.pageSize" :total="total" @current-change="pageChange" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加模块弹窗 -->
    <el-dialog title="新增模块" :visible.sync="layoutConfigVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" destroy-on-close>
      <layout-config-dialog :currentLayoutId="modulesId" :selectedIds="dataList.map(item => item.id)"
        @close="layoutConfigVisible = false" @success="handleLayoutConfigData" />
    </el-dialog>

    <!-- 操作详情 -->
    <el-dialog title="操作详情" :visible.sync="optRecordVisible" fullscreen custom-class="add-material-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close>
      <opt-record :shipId="detailId" />
    </el-dialog>

    <!-- 测试 -->
    <el-dialog title="测试" :visible.sync="testVisible" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="false" destroy-on-close>
      <test @confirm="testConfirm" @close="testVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import api from "@/api";
import Test from "@/components/Test.vue";
import LayoutConfigDialog from "./components/layoutConfigDialog/index.vue";
import OptRecord from "./components/optRecord/index.vue";
import LayoutConfigPreview from "./components/layoutConfigPreView/index.vue";
import { valueByLanguage } from "@/utils/college";
import { cloneDeep } from "lodash";

export default {
  name: "LayoutConfig"
  ,
  components: {
    Test,
    LayoutConfigDialog,
    OptRecord,
    LayoutConfigPreview
  },
  data() {
    return {
      loading: false,
      previewLoading: false,
      modulesId: null,
      modulesStatus: null,
      latestPublishedAt: "",
      params: {
        page: 1,
        pageSize: 50
      },
      total: 0,
      dataList: [],
      previewData: [],
      detailId: null,
      testType: "module", // module | layout
      optRecordVisible: false,
      layoutConfigVisible: false,
      testVisible: false,
      sortableInstance: null,
      // 分栏设置（参照 galaxy：minPercent=30, defaultPercent=30）
      splitPercent: 30,
      isResizing: false,
      _resizeMoveHandler: null,
      _resizeUpHandler: null,
      tableHeight: 300,
      // 状态映射（对齐 galaxy）
      publishStatusMap: {
        0: "未发布",
        1: "已发布"
      }
    };
  },
  mounted() {
    this.bootstrap();
    this.restoreSplitPercent();
    this.calcTableHeight();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    if (this.sortableInstance) {
      this.sortableInstance.destroy();
    }
    this.teardownResizeListeners();
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    leftPaneStyle() {
      return { width: this.splitPercent + "%" };
    }
  },
  methods: {
    calcTableHeight() {
      this.$nextTick(() => {
        const tableWrapper = this.$el.querySelector(".table-wrapper");
        const pager = this.$el.querySelector(".pager");
        if (tableWrapper && pager) {
          // 计算表格高度：容器高度 - 分页器高度 - 分页器 margin
          const wrapperHeight = tableWrapper.clientHeight;
          const pagerHeight = pager.offsetHeight || 50;
          const pagerMargin = 12; // pager 的 margin-top
          this.tableHeight = wrapperHeight - pagerHeight - pagerMargin;
          // 确保最小高度
          if (this.tableHeight < 200) {
            this.tableHeight = 200;
          }
        } else if (tableWrapper) {
          // 如果没有分页器，预留空间
          this.tableHeight = tableWrapper.clientHeight - 50;
          if (this.tableHeight < 200) {
            this.tableHeight = 200;
          }
        }
        // 延迟执行 doLayout，确保 DOM 已更新
        this.$nextTick(() => {
          if (this.$refs.tableRef) {
            this.$refs.tableRef.doLayout();
          }
        });
      });
    },
    handleResize() {
      this.calcTableHeight();
    },
    restoreSplitPercent() {
      try {
        // 分栏宽度单独使用一个 key，避免与预览数据冲突
        const key = "resource_layout_split_percent";
        const v = window && window.localStorage ? window.localStorage.getItem(key) : null;
        const num = v !== null && v !== undefined ? Number(v) : NaN;
        if (!Number.isNaN(num)) {
          this.splitPercent = Math.max(30, Math.min(70, num));
        }
      } catch (e) { }
    },
    persistSplitPercent() {
      try {
        // 分栏宽度单独使用一个 key，避免与预览数据冲突
        const key = "resource_layout_split_percent";
        if (window && window.localStorage) {
          window.localStorage.setItem(key, String(this.splitPercent));
        }
      } catch (e) { }
    },
    startResize(e) {
      if (e && e.button !== 0) return;
      e && e.preventDefault && e.preventDefault();
      this.isResizing = true;
      this._resizeMoveHandler = this.onResizing;
      this._resizeUpHandler = this.stopResize;
      document.addEventListener("mousemove", this._resizeMoveHandler);
      document.addEventListener("mouseup", this._resizeUpHandler);
      if (document.body) {
        document.body.style.cursor = "col-resize";
        document.body.style.userSelect = "none";
      }
    },
    onResizing(e) {
      if (!this.isResizing) return;
      const body = this.$el && this.$el.querySelector
        ? this.$el.querySelector(".layout-config-body")
        : null;
      if (!body) return;
      const rect = body.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const percent = (x / rect.width) * 100;
      this.splitPercent = Math.max(30, Math.min(70, Math.round(percent)));
    },
    stopResize() {
      if (!this.isResizing) return;
      this.isResizing = false;
      this.teardownResizeListeners();
      this.persistSplitPercent();
    },
    teardownResizeListeners() {
      if (this._resizeMoveHandler) {
        document.removeEventListener("mousemove", this._resizeMoveHandler);
        this._resizeMoveHandler = null;
      }
      if (this._resizeUpHandler) {
        document.removeEventListener("mouseup", this._resizeUpHandler);
        this._resizeUpHandler = null;
      }
      if (document.body) {
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      }
    },
    async bootstrap() {
      try {
        await this.initLayoutConfig();
        await this.getList();
        // 从本地存储恢复预览数据（对齐 galaxy）
        this.restorePreviewData();
      } catch (e) {
        // initLayoutConfig 内部会提示，这里不重复 toast
      }
    },
    restorePreviewData() {
      try {
        // 预览数据单独使用一个 key，避免与分栏宽度冲突
        const key = "resource_layout_preview_data";
        const stored = window && window.localStorage ? window.localStorage.getItem(key) : null;
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) {
              this.previewData = parsed;
            }
          } catch (e) {
            // 忽略解析错误
          }
        }
      } catch (e) {
        // 忽略错误
      }
    },
    async initLayoutConfig() {
      // NOTE: 后端对该接口的校验为：type 只能是 1/2，且 clientType 不能为空
      // - type: 1/2（与服务端约定的布局类型）
      // - clientType: galaxy（与其他资源相关接口一致）
      // 这里按素材中心布局约定传 type=2（资料中心通常为 1）
      try {
        const params = {
          type: 2,
          clientType: "galaxy",
          resourceType: "RESOURCE"
        };

        const res = await api.getCurrentLayoutConfig(params);
        this.modulesId = res.data && res.data.id;
        this.modulesStatus = res.data && res.data.status;
        this.latestPublishedAt =
          res.data && res.data.latestPublishedAt ? res.data.latestPublishedAt : "";
      } catch (error) {
        this.modulesId = null;
        this.$message.error(
          (error && error.message) || "获取布局配置失败（clientType/type/resourceType）"
        );
        throw error;
      }
    },
    async getList() {
      if (!this.modulesId) return;
      this.loading = true;
      const res = await api.getLayoutModuleList(this.modulesId, this.params);
      const items = (res.data && res.data.items) ? res.data.items : [];
      this.total = (res.data && res.data.count) ? res.data.count : 0;
      // 兼容字段：把 module 的 name/shipId 等扁平化，方便表格展示
      this.dataList = items.map((it) => ({
        ...it,
        shipId: it.shipId || it.id || it.ship_id,
        statusText: (it.status === 1 ? "上线" : "下线"),
        name: (it.name && it.name[0] && it.name[0].value) ? it.name[0].value : (it.nameText || it.name || "-")
      }));

      await this.getDataResourceList();
      this.loading = false;
      // 数据加载完成后重新计算表格高度并刷新布局
      this.calcTableHeight();
    },
    async getDataResourceList() {
      // 预览：获取每个模块的资源列表（对齐 galaxy：直接修改 dataList 中的 item）
      if (!this.dataList.length) {
        this.previewData = [];
        return;
      }
      this.previewLoading = true;
      const list = [];
      for (const item of this.dataList) {
        const moduleId = item.id;
        const res = await api.getIndexConfigModulesResourceList(moduleId, { page: 1, pageSize: 1000 });
        const resources = (res.data && res.data.items) ? res.data.items : [];
        // 将 resources 添加到 dataList 中（用于表格显示，对齐 galaxy）
        item.resources = resources;
        // 同时添加到 previewData（用于预览）
        list.push({
          ...item,
          resources: resources
        });
      }
      this.previewData = list;
      this.previewLoading = false;
    },
    openLayoutConfig() {
      this.layoutConfigVisible = true;
    },
    saveLayoutConfig() {
      // 对齐 galaxy：保存"预览数据"到本地存储（不发请求）
      this.previewLoading = true;
      try {
        const cloned = cloneDeep(this.dataList || []);
        this.previewData = cloned;
        // 预览数据单独使用一个 key，避免与分栏宽度冲突
        const key = "resource_layout_preview_data";
        if (window && window.localStorage) {
          window.localStorage.setItem(key, JSON.stringify(cloned));
        }
      } catch (e) {
        this.$message.error("保存预览数据失败");
      } finally {
        this.previewLoading = false;
      }
    },
    async handleLayoutConfigData(data) {
      const selectedData = data && data.selectedData ? data.selectedData : [];
      const delSelectedData = data && data.delSelectedData ? data.delSelectedData : [];
      await Promise.all([
        selectedData.length
          ? api.addLayoutModule(this.modulesId, { itemIds: selectedData })
          : Promise.resolve(),
        delSelectedData.length
          ? api.removeLayoutModule(this.modulesId, { itemIds: delSelectedData })
          : Promise.resolve()
      ]);
      this.$message.success("操作成功");
      this.layoutConfigVisible = false;
      await this.initLayoutConfig();
      await this.getList();
    },
    removeLayoutModuleAction(selectedIds) {
      this.$confirm("是否确认要移出？", "移出提示")
        .then(async () => {
          await api.removeLayoutModule(this.modulesId, { itemIds: selectedIds });
          await this.getList();
          await this.initLayoutConfig();
        })
        .catch(() => { });
    },
    initSortable(e) {
      if (e && e.preventDefault) e.preventDefault();
      // 修复：表格在右侧，应该选择右侧的表格（对齐 galaxy）
      const wrapper = document.querySelector(".layout-right .el-table__body-wrapper tbody") ||
        document.querySelector(".el-table__body-wrapper tbody");
      if (!wrapper) return;
      if (this.sortableInstance) {
        this.sortableInstance.destroy();
        this.sortableInstance = null;
      }

      this.sortableInstance = Sortable.create(wrapper, {
        animation: 150,
        handle: ".drag-btn",
        onEnd: async ({ newIndex, oldIndex }) => {
          if (newIndex === oldIndex) return;
          try {
            const currentNode = this.dataList.splice(oldIndex, 1)[0];
            this.dataList.splice(newIndex, 0, currentNode);
            await this.$nextTick();

            // 简化 ordinal 计算：用相邻的 ordinal 取中值；无则时间戳
            const prev = this.dataList[newIndex - 1];
            const next = this.dataList[newIndex + 1];
            let newOrdinal = null;
            if (!prev && next && next.ordinal !== undefined) newOrdinal = next.ordinal - 0.01;
            else if (!next && prev && prev.ordinal !== undefined) newOrdinal = Date.now();
            else if (prev && next && prev.ordinal !== undefined && next.ordinal !== undefined) newOrdinal = (prev.ordinal + next.ordinal) / 2;
            else newOrdinal = Date.now();

            newOrdinal = Math.round(newOrdinal * 100) / 100;
            currentNode.ordinal = newOrdinal;

            await api.updateLayoutModuleOrdinal(currentNode.shipId, { ordinal: newOrdinal });
          } catch (err) { }
        }
      });
    },
    openOptRecord(row) {
      this.detailId = row && row.shipId;
      this.optRecordVisible = true;
    },
    handlePublish() {
      this.$confirm("是否确认要发布?", "发布提示")
        .then(async () => {
          await api.updateLayoutConfigStatus(this.modulesId, { status: 1 });
          await this.initLayoutConfig();
          await this.getList();
          this.$message.success("发布成功");
        })
        .catch(() => { });
    },
    openTest(row, type) {
      this.testType = type;
      this.detailId = type === "module" ? (row && row.shipId) : this.modulesId;
      this.testVisible = true;
    },
    testConfirm(data) {
      const req = this.testType === "module"
        ? api.testLayoutModule(this.detailId, data)
        : api.testLayoutConfig(this.detailId, data);
      req
        .then(() => {
          this.$message.success("测试成功");
          this.testVisible = false;
        })
        .catch((err) => {
          this.$message.error((err && err.message) || "测试失败");
        });
    },
    handleRowClick() { },
    getThumbnail(data) {
      if (!data) return "";

      // STICKER, TEMPLATE, MATERIAL 类型使用 thumbnail（对齐 galaxy：直接取第一个元素的 value）
      if (["STICKER", "TEMPLATE", "MATERIAL"].includes(data.resourceType)) {
        if (data.thumbnail && Array.isArray(data.thumbnail) && data.thumbnail.length) {
          const firstThumb = data.thumbnail[0];
          return (firstThumb && firstThumb.value) ? firstThumb.value : "";
        }
      }
      // COLLECTION 类型使用 bgFileAssetId（对齐 galaxy：使用 valueByLanguage 返回对象，然后取 url）
      else if (data.resourceType === "COLLECTION") {
        if (data.bgFileAssetId && Array.isArray(data.bgFileAssetId)) {
          const bg = data.bgFileAssetId.find(item => item.locale === "zh_CN");
          if (bg && bg.url) {
            return bg.url;
          }
          // 如果没有 url，尝试使用 value（可能是 URL 字符串）
          if (bg && bg.value) {
            return bg.value;
          }
        }
      }
      // BANNER 类型使用 fileAssetId（对齐 galaxy：使用 valueByLanguage 返回对象，然后取 url）
      else if (data.resourceType === "BANNER") {
        if (data.fileAssetId && Array.isArray(data.fileAssetId)) {
          const file = data.fileAssetId.find(item => item.locale === "zh_CN");
          if (file && file.url) {
            return file.url;
          }
          // 如果没有 url，尝试使用 value（可能是 URL 字符串）
          if (file && file.value) {
            return file.value;
          }
        }
      }

      return "";
    },
    getPreviewSrcList(resources) {
      if (!resources || !Array.isArray(resources)) return [];
      return resources.map(item => this.getThumbnail(item)).filter(Boolean);
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    }
  }
};
</script>

<style scoped>
.layout-config {
  height: 100%;
  overflow: hidden;
}

.layout-config-body {
  display: flex;
  /* gap: 16px; */
  height: 100%;
  min-height: 420px;
}

.layout-left {
  min-width: 320px;
  overflow: hidden;
}

.pane-inner {
  padding: 16px;
  padding-right: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.pane-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pane-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pane-title {
  font-weight: 700;
  color: #303133;
}

.pane-sub-line {
  font-size: 12px;
  color: #409eff;
  line-height: 18px;
}

.pane-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pane-content {
  margin-top: 16px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.layout-splitter {
  cursor: col-resize;
  height: 100%;
  width: 6px;
  background: #e5e6eb;
  box-sizing: border-box;
  opacity: 0.2;
  position: relative;
  background-clip: padding-box;
}

.layout-splitter:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  height: 18px;
  background-image: radial-gradient(circle, #000 1px, transparent 1.5px);
  background-size: 2px 3px;
  background-repeat: repeat-y;
}

.layout-right {
  flex: 1;
  min-width: 0;
  border-left: 1px solid #f5f5f5;
  overflow: hidden;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.table-wrapper :deep(.el-table) {
  flex: 1;
  border: 1px solid #ebeef5;
}

.table-wrapper :deep(.el-table .el-table__fixed::before),
.table-wrapper :deep(.el-table .el-table__fixed-right::before) {
  display: none;
}

.table-wrapper :deep(.el-table__body-wrapper) {
  overflow-x: auto !important;
  overflow-y: auto !important;
  max-height: none !important;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar-track {
  background: transparent;
}

.table-wrapper :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 3px;
  transition: background-color 0.2s ease;
}

.table-wrapper:hover :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.3);
}

.table-wrapper:hover :deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.5);
}

.table-wrapper :deep(.el-table__body-wrapper) {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  transition: scrollbar-color 0.2s ease;
}

.table-wrapper:hover :deep(.el-table__body-wrapper) {
  scrollbar-color: rgba(144, 147, 153, 0.3) transparent;
}

.drag-btn {
  cursor: grab;
}

.op-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* gap: 8px; */
}

.op-drag {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
}

.thumbnail-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.layout-config,
.layout-config-body {
  height: 100%;
}

.layout-config-body {
  display: flex;
}

.layout-left,
.layout-right {
  height: 100%;
  display: flex;
}

.layout-right {
  flex: 1;
}

.pane-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.pane-header {
  flex-shrink: 0;
}

.pager {
  margin-top: 12px;
  flex-shrink: 0;
}

:deep(.add-material-dialog.el-dialog) {
  display: flex;
  flex-direction: column;
  height: 100vh;
  margin: 0;
}

:deep(.add-material-dialog.el-dialog .el-dialog__header) {
  flex-shrink: 0;
}

:deep(.add-material-dialog.el-dialog .el-dialog__body) {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

:deep(.add-material-dialog.el-dialog .el-dialog__body > .opt-record) {
  flex: 1;
  min-height: 0;
}
</style>
